<template>
  <div>
    <div class="fixed top-0 left-0 right-0 z-10 flex flex-auto"
     :style="headerStylesPerformance" ref="header">
      <zt-menu />
      <!-- Header is hidden when running inside an iframe with valid token -->
      <zt-header v-show="!iframeTokenValid" class="flex-1 flex" />
    </div>
    <div
      class="pb-20 lg:pb-0 lg:pl-6 xl:pl-6 md:pl-6"
      :class="{ 'pt-16': !iframeTokenValid, 'lg:pt-20': !iframeTokenValid }"
      ref="main"
      :style="styles"
    >
      <router-view />
    </div>
  </div>
</template>

<script>
import { mapActions  } from 'vuex';
import ZtHeader from '@/components/Header'
import ZtMenu from '@/components/MenuBar'
import {
  store,
  mutations
} from '@/components/commons/Observables/refHeaderComponent'
import { useMenuBar } from '@/components/MenuBar/hooks/useMenuBar'
import { useWindowResize } from '@sichern/ui-elements'

export default {
  name: 'Main',
  provide: { store, mutations },
  components: {
    ZtHeader,
    ZtMenu
  },
  data() {
    return {
      windowSize: useWindowResize(this)
    }
  },
  created() {
    this.setLocale()
  },
  computed: {
    isMobile() {
      return this.windowSize.width < 1024
    },
    styles() {
      if (this.isMobile) {
        if (this.iframeTokenValid) {
          return {
            display: 'flex',
            justifyContent: 'center'
          }
        }
        return {}
      }
      return {
        paddingLeft: `calc(${useMenuBar.styles.width} + 15px)`
      }
    },
    iframeTokenValid() {
      return this.$iframeMessages && this.$iframeMessages.isTokenValid();
    },
    headerStylesPerformance() {
      if (this.iframeTokenValid) {
        return {
          background: '#fafafa',
          ...(this.isMobile ? { display: 'flex', justifyContent: 'center' } : {})
        }
      }
      return {}
    },

  },
  methods: {
    ...mapActions(['setLocale'])
  },
}
</script>

<style scoped>
::v-deep .text-zt-primary-200,
::v-deep .text-zt-primary-100,
::v-deep .text-zt-dark-400,
::v-deep .text-purple-600 {
  color: var(--branding-titleColor, var(--v-primary-base));
}
::v-deep .bg-zt-primary-200.zt-button:not(.zt-button-outline-primary,.zt-button-bg-white) {
  background-color: var(--branding-primary, var(--v-primary-base));
  color: var(--branding-textColor, var(--v-primary-base));
}
::v-deep .bg-zt-primary-200.zt-button.zt-button-outline-primary,
::v-deep .v-avatar.border-primary {
  color: var(--branding-textColor, var(--v-primary-base));
  border-color: var(--branding-primary, var(--v-primary-base));
  background: var(--branding-lightThemeBg,white);
}
::v-deep .zt-avatar.bg-zt-primary-200,
::v-deep.bg-zt-primary-200 {
  background-color: var(--branding-lightThemeBg,var(--branding-primary, var(--v-primary-base)));
}


</style>
